var map = {
	"./apryse-logo.svg": 702,
	"./calibrate.svg": 703,
	"./digital_signature_empty.svg": 704,
	"./digital_signature_error.svg": 705,
	"./digital_signature_valid.svg": 706,
	"./digital_signature_warning.svg": 707,
	"./function.svg": 708,
	"./group-annotations-icon.svg": 709,
	"./ic-accounting.svg": 710,
	"./ic-align-bottom-ios.svg": 711,
	"./ic-align-middle-ios.svg": 712,
	"./ic-align-top-ios.svg": 713,
	"./ic-alignment-bottom.svg": 714,
	"./ic-alignment-center-horizontal.svg": 715,
	"./ic-alignment-center-vertical.svg": 716,
	"./ic-alignment-left.svg": 717,
	"./ic-alignment-main.svg": 718,
	"./ic-alignment-right.svg": 719,
	"./ic-alignment-top.svg": 720,
	"./ic-audio-redact.svg": 721,
	"./ic-automatic.svg": 722,
	"./ic-bookmark.svg": 723,
	"./ic-border-all.svg": 724,
	"./ic-border-bottom.svg": 725,
	"./ic-border-color.svg": 726,
	"./ic-border-horizontal.svg": 727,
	"./ic-border-inside.svg": 728,
	"./ic-border-left.svg": 729,
	"./ic-border-main.svg": 730,
	"./ic-border-none.svg": 731,
	"./ic-border-outside.svg": 732,
	"./ic-border-right.svg": 733,
	"./ic-border-top.svg": 734,
	"./ic-border-vertical.svg": 735,
	"./ic-calculator.svg": 736,
	"./ic-calendar-time.svg": 737,
	"./ic-calendar.svg": 738,
	"./ic-calibrate.svg": 739,
	"./ic-clock-hour.svg": 740,
	"./ic-copy-color.svg": 741,
	"./ic-currency.svg": 742,
	"./ic-decrease-decimal.svg": 743,
	"./ic-delete-column-shift-left.svg": 744,
	"./ic-delete-column-shift-up.svg": 745,
	"./ic-delete-column.svg": 746,
	"./ic-delete-page.svg": 747,
	"./ic-delete-row.svg": 748,
	"./ic-delete.svg": 749,
	"./ic-distribute-horizontal.svg": 750,
	"./ic-distribute-vertical.svg": 751,
	"./ic-dollar-circle-rounded.svg": 752,
	"./ic-dollar-circle.svg": 753,
	"./ic-edit-page.svg": 754,
	"./ic-file-cad.svg": 755,
	"./ic-file-doc.svg": 756,
	"./ic-file-etc.svg": 757,
	"./ic-file-img.svg": 758,
	"./ic-file-pdf.svg": 759,
	"./ic-file-ppt.svg": 760,
	"./ic-file-xls.svg": 761,
	"./ic-fill-and-sign.svg": 762,
	"./ic-fill.svg": 763,
	"./ic-filter-alt.svg": 764,
	"./ic-filter-with-dot.svg": 765,
	"./ic-folder-open.svg": 766,
	"./ic-format-page.svg": 767,
	"./ic-full-frame-video-and-audio-redact.svg": 768,
	"./ic-full-frame-video-redact.svg": 769,
	"./ic-hamburger-menu.svg": 770,
	"./ic-increase-decimal.svg": 771,
	"./ic-indent-decrease.svg": 772,
	"./ic-indent-increase.svg": 773,
	"./ic-insert text.svg": 774,
	"./ic-insert-column-left.svg": 775,
	"./ic-insert-column-right.svg": 776,
	"./ic-insert-column-shift-down.svg": 777,
	"./ic-insert-column-shift-right.svg": 778,
	"./ic-insert-column.svg": 779,
	"./ic-insert-row-bottom.svg": 780,
	"./ic-insert-row-top.svg": 781,
	"./ic-layer.svg": 782,
	"./ic-merge.svg": 783,
	"./ic-number.svg": 784,
	"./ic-paragraph.svg": 785,
	"./ic-percent.svg": 786,
	"./ic-replace text.svg": 787,
	"./ic-table.svg": 788,
	"./ic-text-clip.svg": 789,
	"./ic-text-overflow.svg": 790,
	"./ic-text-wrap.svg": 791,
	"./ic-text-wrapping.svg": 792,
	"./ic-unmerge.svg": 793,
	"./ic-wv3d-properties-panel-menu.svg": 794,
	"./ic_annotation_cloudy_rectangular_area_black_24px.svg": 795,
	"./ic_annotation_ellipse_area_black.svg": 796,
	"./ic_annotation_eraser_black_24px.svg": 797,
	"./ic_annotation_rectangular_area_black_24px.svg": 798,
	"./ic_annotation_signature_black_24px.svg": 799,
	"./ic_annotation_strikeout_black_24px.svg": 800,
	"./ic_annotation_underline_black_24px.svg": 801,
	"./ic_bookmarks_black_24px.svg": 802,
	"./ic_check_black_24px.svg": 803,
	"./ic_close_black_24px.svg": 804,
	"./ic_copy_black_24px.svg": 805,
	"./ic_crop_black_24px.svg": 806,
	"./ic_edit_page_24px.svg": 807,
	"./ic_fileattachment_24px.svg": 808,
	"./ic_layers_24px.svg": 809,
	"./ic_pause_24px.svg": 810,
	"./ic_play_24px.svg": 811,
	"./ic_replace.svg": 812,
	"./ic_select_black_24px.svg": 813,
	"./ic_snipping_black_24px.svg": 814,
	"./ic_sound_24px.svg": 815,
	"./ic_thumbnails_grid_black_24px.svg": 816,
	"./icon-accessibility-mode.svg": 817,
	"./icon-action-redo.svg": 818,
	"./icon-action-undo.svg": 819,
	"./icon-active-indicator.svg": 820,
	"./icon-add-file.svg": 821,
	"./icon-add-folder.svg": 822,
	"./icon-alert.svg": 823,
	"./icon-annotate-ribbon.svg": 824,
	"./icon-annotation-select-multiple.svg": 825,
	"./icon-annotation-status-accepted.svg": 826,
	"./icon-annotation-status-cancelled.svg": 827,
	"./icon-annotation-status-completed.svg": 828,
	"./icon-annotation-status-marked.svg": 829,
	"./icon-annotation-status-none.svg": 830,
	"./icon-annotation-status-rejected.svg": 831,
	"./icon-annotation-status-unmarked.svg": 832,
	"./icon-arrow-back.svg": 833,
	"./icon-arrow-down.svg": 834,
	"./icon-arrow-left.svg": 835,
	"./icon-arrow-right.svg": 836,
	"./icon-arrow-to-bottom.svg": 837,
	"./icon-arrow-to-middle.svg": 838,
	"./icon-arrow-to-top.svg": 839,
	"./icon-arrow-up.svg": 840,
	"./icon-chat-bubble.svg": 841,
	"./icon-check.svg": 842,
	"./icon-chevron-down.svg": 843,
	"./icon-chevron-left.svg": 844,
	"./icon-chevron-right.svg": 845,
	"./icon-chevron-up.svg": 846,
	"./icon-close.svg": 847,
	"./icon-comments-filter.svg": 848,
	"./icon-compare-change.svg": 849,
	"./icon-compare-file-open.svg": 850,
	"./icon-content-edit.svg": 851,
	"./icon-copy.svg": 852,
	"./icon-copy2.svg": 853,
	"./icon-cut.svg": 854,
	"./icon-dark-mode-option.svg": 855,
	"./icon-delete-line.svg": 856,
	"./icon-detach-toolbar.svg": 857,
	"./icon-double-chevron-down.svg": 858,
	"./icon-download.svg": 859,
	"./icon-drag-handle.svg": 860,
	"./icon-edit-form-field.svg": 861,
	"./icon-error.svg": 862,
	"./icon-folder.svg": 863,
	"./icon-form-field-button.svg": 864,
	"./icon-form-field-checkbox.svg": 865,
	"./icon-form-field-combobox.svg": 866,
	"./icon-form-field-listbox.svg": 867,
	"./icon-form-field-radiobutton.svg": 868,
	"./icon-form-field-signature.svg": 869,
	"./icon-form-field-text.svg": 870,
	"./icon-header-chat-line.svg": 871,
	"./icon-header-compare.svg": 872,
	"./icon-header-file-picker-line.svg": 873,
	"./icon-header-full-screen-exit.svg": 874,
	"./icon-header-full-screen.svg": 875,
	"./icon-header-page-manipulation-insert-above.svg": 876,
	"./icon-header-page-manipulation-line.svg": 877,
	"./icon-header-page-manipulation-page-layout-cover-line.svg": 878,
	"./icon-header-page-manipulation-page-layout-double-page-line.svg": 879,
	"./icon-header-page-manipulation-page-layout-single-page-line.svg": 880,
	"./icon-header-page-manipulation-page-rotation-clockwise-line.svg": 881,
	"./icon-header-page-manipulation-page-rotation-counterclockwise-line.svg": 882,
	"./icon-header-page-manipulation-page-transition-continuous-page-line.svg": 883,
	"./icon-header-page-manipulation-page-transition-page-by-page-line.svg": 884,
	"./icon-header-page-manipulation-page-transition-reader.svg": 885,
	"./icon-header-pan.svg": 886,
	"./icon-header-print-line.svg": 887,
	"./icon-header-search.svg": 888,
	"./icon-header-select-line.svg": 889,
	"./icon-header-settings-line.svg": 890,
	"./icon-header-sidebar-line.svg": 891,
	"./icon-header-zoom-fit-to-page.svg": 892,
	"./icon-header-zoom-fit-to-width.svg": 893,
	"./icon-header-zoom-in-line.svg": 894,
	"./icon-header-zoom-marquee.svg": 895,
	"./icon-header-zoom-out-line.svg": 896,
	"./icon-image-green.svg": 897,
	"./icon-index-panel-list.svg": 898,
	"./icon-info.svg": 899,
	"./icon-insert-ribbon.svg": 900,
	"./icon-keyboard.svg": 901,
	"./icon-light-mode-option.svg": 902,
	"./icon-linestyle-cloudy-line.svg": 903,
	"./icon-linestyle-dash-1-4-8-4.svg": 904,
	"./icon-linestyle-dash-2-2.svg": 905,
	"./icon-linestyle-dash-3-6-10-6.svg": 906,
	"./icon-linestyle-dash-4-4.svg": 907,
	"./icon-linestyle-dash-4-6-10-6.svg": 908,
	"./icon-linestyle-dash-6-6.svg": 909,
	"./icon-linestyle-dashed-line-wide.svg": 910,
	"./icon-linestyle-dotted-line-wide.svg": 911,
	"./icon-linestyle-end-arrow-closed-reverse.svg": 912,
	"./icon-linestyle-end-arrow-closed.svg": 913,
	"./icon-linestyle-end-arrow-open-reverse.svg": 914,
	"./icon-linestyle-end-arrow-open.svg": 915,
	"./icon-linestyle-end-butt.svg": 916,
	"./icon-linestyle-end-circle.svg": 917,
	"./icon-linestyle-end-diamond.svg": 918,
	"./icon-linestyle-end-slash.svg": 919,
	"./icon-linestyle-end-square.svg": 920,
	"./icon-linestyle-none.svg": 921,
	"./icon-linestyle-solid-line-wide.svg": 922,
	"./icon-linestyle-solid-line.svg": 923,
	"./icon-linestyle-start-arrow-closed-reverse.svg": 924,
	"./icon-linestyle-start-arrow-closed.svg": 925,
	"./icon-linestyle-start-arrow-open-reverse.svg": 926,
	"./icon-linestyle-start-arrow-open.svg": 927,
	"./icon-linestyle-start-butt.svg": 928,
	"./icon-linestyle-start-circle.svg": 929,
	"./icon-linestyle-start-diamond.svg": 930,
	"./icon-linestyle-start-slash.svg": 931,
	"./icon-linestyle-start-square.svg": 932,
	"./icon-lock-wire.svg": 933,
	"./icon-lock.svg": 934,
	"./icon-magnifying-glass.svg": 935,
	"./icon-menu-add.svg": 936,
	"./icon-menu-align-centre.svg": 937,
	"./icon-menu-align-left.svg": 938,
	"./icon-menu-align-right.svg": 939,
	"./icon-menu-bold.svg": 940,
	"./icon-menu-both-align.svg": 941,
	"./icon-menu-center-align.svg": 942,
	"./icon-menu-checkmark.svg": 943,
	"./icon-menu-italic.svg": 944,
	"./icon-menu-left-align.svg": 945,
	"./icon-menu-right-align.svg": 946,
	"./icon-menu-style-line.svg": 947,
	"./icon-menu-text-underline.svg": 948,
	"./icon-no-marked-redactions.svg": 949,
	"./icon-office-editor-bullet-list.svg": 950,
	"./icon-office-editor-circle.svg": 951,
	"./icon-office-editor-column.svg": 952,
	"./icon-office-editor-line-spacing.svg": 953,
	"./icon-office-editor-list-style-arrow.svg": 954,
	"./icon-office-editor-list-style-bullet.svg": 955,
	"./icon-office-editor-list-style-check.svg": 956,
	"./icon-office-editor-list-style-diamond.svg": 957,
	"./icon-office-editor-list-style-latin-roman.svg": 958,
	"./icon-office-editor-list-style-number-decimal.svg": 959,
	"./icon-office-editor-list-style-number-latin-1.svg": 960,
	"./icon-office-editor-list-style-number-latin-2.svg": 961,
	"./icon-office-editor-list-style-roman-latin.svg": 962,
	"./icon-office-editor-list-style-square-bullet.svg": 963,
	"./icon-office-editor-list-style-square.svg": 964,
	"./icon-office-editor-margin.svg": 965,
	"./icon-office-editor-number-list.svg": 966,
	"./icon-office-editor-page-break-split.svg": 967,
	"./icon-office-editor-page-break.svg": 968,
	"./icon-office-editor-toggle-non-printing-characters.svg": 969,
	"./icon-open-folder.svg": 970,
	"./icon-operation-eraser.svg": 971,
	"./icon-operation-redo.svg": 972,
	"./icon-operation-undo.svg": 973,
	"./icon-page-controls.svg": 974,
	"./icon-page-insertion-insert.svg": 975,
	"./icon-page-manipulation-extract.svg": 976,
	"./icon-page-move-down.svg": 977,
	"./icon-page-move-left.svg": 978,
	"./icon-page-move-right.svg": 979,
	"./icon-page-move-up.svg": 980,
	"./icon-page-replacement.svg": 981,
	"./icon-panel-outlines.svg": 982,
	"./icon-panel-thumbnail-line.svg": 983,
	"./icon-paste-without-formatting.svg": 984,
	"./icon-paste.svg": 985,
	"./icon-pdf-portfolio.svg": 986,
	"./icon-pencil-line.svg": 987,
	"./icon-plus-sign.svg": 988,
	"./icon-portfolio-file.svg": 989,
	"./icon-portfolio-folder.svg": 990,
	"./icon-post-reply.svg": 991,
	"./icon-redact-panel.svg": 992,
	"./icon-save.svg": 993,
	"./icon-signature-plus-disabled.svg": 994,
	"./icon-signature-plus-sign.svg": 995,
	"./icon-style-panel-toggle.svg": 996,
	"./icon-sync.svg": 997,
	"./icon-text-bold.svg": 998,
	"./icon-text-italic.svg": 999,
	"./icon-text-justify-center.svg": 1000,
	"./icon-text-redaction.svg": 1001,
	"./icon-text-strikeout.svg": 1002,
	"./icon-text-underline.svg": 1003,
	"./icon-thumbtack.svg": 1004,
	"./icon-tool-arc.svg": 1005,
	"./icon-tool-callout-line.svg": 1006,
	"./icon-tool-changeview.svg": 1007,
	"./icon-tool-check-stamp.svg": 1008,
	"./icon-tool-comment-line.svg": 1009,
	"./icon-tool-cross-stamp.svg": 1010,
	"./icon-tool-dot-stamp.svg": 1011,
	"./icon-tool-fill-and-sign-calendar.svg": 1012,
	"./icon-tool-highlight.svg": 1013,
	"./icon-tool-image-line.svg": 1014,
	"./icon-tool-link.svg": 1015,
	"./icon-tool-measurement-arc.svg": 1016,
	"./icon-tool-measurement-area-ellipse-line.svg": 1017,
	"./icon-tool-measurement-area-line.svg": 1018,
	"./icon-tool-measurement-area-polygon-line.svg": 1019,
	"./icon-tool-measurement-cloud-area-line.svg": 1020,
	"./icon-tool-measurement-distance-line.svg": 1021,
	"./icon-tool-measurement-perimeter.svg": 1022,
	"./icon-tool-model3d.svg": 1023,
	"./icon-tool-more.svg": 1024,
	"./icon-tool-page-redact.svg": 1025,
	"./icon-tool-pen-highlight.svg": 1026,
	"./icon-tool-pen-line.svg": 1027,
	"./icon-tool-redaction-area.svg": 1028,
	"./icon-tool-select-area-redaction.svg": 1029,
	"./icon-tool-select-pages.svg": 1030,
	"./icon-tool-shape-arrow.svg": 1031,
	"./icon-tool-shape-cloud.svg": 1032,
	"./icon-tool-shape-line.svg": 1033,
	"./icon-tool-shape-oval.svg": 1034,
	"./icon-tool-shape-polygon.svg": 1035,
	"./icon-tool-shape-polyline.svg": 1036,
	"./icon-tool-shape-rectangle.svg": 1037,
	"./icon-tool-signature.svg": 1038,
	"./icon-tool-stamp-line.svg": 1039,
	"./icon-tool-text-free-text.svg": 1040,
	"./icon-tool-text-manipulation-highlight.svg": 1041,
	"./icon-tool-text-manipulation-squiggly.svg": 1042,
	"./icon-tool-text-manipulation-underline.svg": 1043,
	"./icon-tool-unlink.svg": 1044,
	"./icon-tools-more-active.svg": 1045,
	"./icon-tools-more-vertical.svg": 1046,
	"./icon-tools-more.svg": 1047,
	"./icon-unposted-comment.svg": 1048,
	"./icon-view-ribbon.svg": 1049,
	"./icon-view.svg": 1050,
	"./icon-watermark-panel.svg": 1051,
	"./icon-zoom-thumb-in.svg": 1052,
	"./icon-zoom-thumb-out.svg": 1053,
	"./illustration - empty state - outlines.svg": 1054,
	"./multi select.svg": 1055,
	"./redact-icons-credit-card.svg": 1056,
	"./redact-icons-email.svg": 1057,
	"./redact-icons-image.svg": 1058,
	"./redact-icons-phone-number.svg": 1059,
	"./style-panel-no-tool-selected.svg": 1060,
	"./textselect_cursor.svg": 1061,
	"./ungroup-annotations-icon.svg": 1062
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 458;